import { Injectable } from '@angular/core';
import { ViewConstants } from 'src/app/constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SharedDataService } from './shared-data.service';
import { SharedFunctionService } from './shared-func.service';
declare let CONfireTag: any;

@Injectable({
  providedIn: 'root'
})
export class CaptureAnalyticsService {
  deviceType = null;
  constructor(private readonly deviceService: DeviceDetectorService, 
    private readonly sharedDataService: SharedDataService, private readonly sharedFunService: SharedFunctionService) {
    this.getDeviceInfo();
  }

  public paramsDictionary = {
    'globalBlock': (_dynamicGlobalBlockParamsObject) => {
      let globalParamsObject: any = {};
      const dealerPostalAddress = this.sharedDataService?.dealerPostalAddress;
      globalParamsObject = {
        zipcode: this?.sharedDataService?.dealerZipCode ?? '',
        error_type: '',
        tda_code: '',
        breakpoint: '',
        device_type: this.deviceType,
        dealer_brand: this?.sharedDataService?.relationshipTypeCode ?? '',
        dealer_code: this?.sharedDataService?.dealerCode ?? '',
        dealer_has_espanol: '',
        dealer_has_schedule_service: '',
        dealer_has_service_only: '',
        dealer_has_tire_center: '',
        dealer_has_txm: '',
        dealer_zipcode: this?.sharedDataService?.dealerZipCode ?? '',
        dealer_name: this?.sharedDataService?.dealerName ?? '',
        dealer_city: dealerPostalAddress?.cityName?.value ?? '',
        dealer_state: dealerPostalAddress?.stateOrProvinceCountrySubDivisionID?.value ?? '',
        dealer_employee_ID: this.sharedDataService.loggedInUserId ?? '',
        user_customer_central_id: '',
        user_si_id: '',
        user_digital_garage_id: '',
        user_to_id: '',
        user_logged_status: '',
        // user_status_type: this.constants.isMSTConnectedToTFS === true ? "lcp – connected" : "lcp – not connected",
        user_con_id: this.setCustomerValues(this.sharedDataService?.customerData?.customerId),
        user_zipcode: this.setCustomerValues(this.sharedDataService?.customerData?.zipCode),
        user_city: this.setCustomerValues(this.sharedDataService?.customerData?.city),
        tool_name: 'console'
      }
      return globalParamsObject;
    },
    'pageBlock': (pageBlockObject) => {
      const pageBlockParamsObject: any = {
        content_section: '',
        content_subsection: '',
        content_item: ''
      }
      for (const key in pageBlockObject) {
        pageBlockParamsObject[key] = pageBlockObject[key];
      }
      return pageBlockParamsObject;
    },
    'errorBlock': (dynamicErrorBlockParamsObject) => {
      const errorBlockParamsObject = {
        error_field: []
      }
      for (const key in dynamicErrorBlockParamsObject) {
        errorBlockParamsObject[key] = dynamicErrorBlockParamsObject[key];
      }
      return errorBlockParamsObject;
    },
    'linkBlock': (linkBlockParamsObject) => {
      const linkParamsObject: any = {
        link_text: '',
        link_href: '',
        link_url: '',
        link_type_title: '',
        link_trigger: '',
        link_action: '',
        link_type: ''
      }
      for (const key in linkBlockParamsObject) {
        linkParamsObject[key] = linkBlockParamsObject[key];
      }
      return linkParamsObject;
    },
    'vehicleBlock': (dynamicVehicleBlockParamsObject) => {
      let vehicleParamsObject = {};
      const vehicleDetails = dynamicVehicleBlockParamsObject;
      if (vehicleDetails !== undefined && vehicleDetails !== null && Object.keys(vehicleDetails).length > 0) {
        vehicleParamsObject = {
          series_code: vehicleDetails.series,
          series_year: vehicleDetails.display_year,
          series_grade: vehicleDetails.trim,
          series_inventory_type: '',
          series_number: vehicleDetails.model_code,
          series_vehicleid: '',
          // series_category: (this.commonUtilities.getSelectedVehicleCategory() !== undefined && this.commonUtilities.getSelectedVehicleCategory() !== null) ? this.commonUtilities.getSelectedVehicleCategory() : '',
          // series_brand: (this.commonUtilities.getRelationshipTypeCode().toUpperCase() === this.constants.lexus.toUpperCase()) ? this.constants.lexus : this.constants.toyota,
          series_msrp: vehicleDetails.totalMsrp,
          series_fuel_type: (vehicleDetails.vehicleDetailResponseObject !== undefined && vehicleDetails.vehicleDetailResponseObject !== null) ? ((vehicleDetails.vehicleDetailResponseObject.engine !== undefined && vehicleDetails.vehicleDetailResponseObject.engine !== null) ? vehicleDetails.vehicleDetailResponseObject.engine.fuelType : '') : ((vehicleDetails.engine !== undefined && vehicleDetails.engine !== null && typeof (vehicleDetails.engine) !== 'string') ? vehicleDetails.engine.fuelType : ''),
          // series_accessories_name: this.commonUtilities.constructAddedAccessoriesString(vehicleDetails.addedAccessoriesArray),
          series_color_ext_code: vehicleDetails.exteriorColorCode,
          series_color_ext: vehicleDetails.exteriorColorDescription,
          series_color_int_code: vehicleDetails.interiorColorCode,
          series_color_int: vehicleDetails.interiorColorDescription,
          series_engine: vehicleDetails.engine,
          series_transmission: vehicleDetails.transmission,
          series_body_style: vehicleDetails.bodyStyle,
          // series_packages: this.commonUtilities.constructPackagesAndOptionsString(vehicleDetails.packagesAndOptions),
          series_vin: vehicleDetails.vin,
          series_used_inventory_cert_level: vehicleDetails.vehicleDetailResponseObject.certificationType
        }
      } else {
        vehicleParamsObject = {
          series_code: '',
          series_year: '',
          series_grade: '',
          series_inventory_type: '',
          series_number: '',
          series_vehicleid: '',
          series_category: '',
          series_brand: '',
          series_msrp: '',
          series_fuel_type: '',
          series_accessories_name: '',
          series_color_ext_code: '',
          series_color_ext: '',
          series_color_int_code: '',
          series_color_int: '',
          series_engine: '',
          series_transmission: '',
          series_body_style: '',
          series_packages: '',
          series_vin: '',
          series_used_inventory_cert_level:''
        }
      }
      return vehicleParamsObject;
    },
    'tradeInVehicleBlock': (dynamicTradeInBlockParamsObject) => {
      let tradeInParamsObject: any = null;
      const tradeInDetails = '';
      let tradeInVehicleBrands = '';
      if (tradeInDetails.length > 0 && Object.keys(dynamicTradeInBlockParamsObject).length === 0) {
        for (let count of tradeInDetails) {
          tradeInVehicleBrands = tradeInVehicleBrands + count['make'];
        }
        tradeInParamsObject = {
          trade_in_veh_series_code: '',
          trade_in_veh_series_year: '',
          trade_in_series_brand: tradeInVehicleBrands,
          trade_in_veh_type:'',
        }
      } else {
        tradeInParamsObject = {
          trade_in_veh_series_code: '',
          trade_in_veh_series_year: '',
          trade_in_series_brand: '',
          trade_in_veh_type:'',
        }
        for (const key in dynamicTradeInBlockParamsObject) {
          tradeInParamsObject[key] = dynamicTradeInBlockParamsObject[key];
        }
      }
      return tradeInParamsObject;
    },
    'paymentEstimatorBlock': (paymentEstimatorBlockParams) => {
      let paymentEstimatorParamsObject: any = {};
      let pricingDetails;// = this.commonUtilities.getPricingDetail()[0];
      if (pricingDetails === undefined || pricingDetails === null || pricingDetails.length === 0) {
        pricingDetails = paymentEstimatorBlockParams;
      }
      if (pricingDetails === undefined || Object.keys(pricingDetails).length === 0) {
        paymentEstimatorParamsObject = {};
      } else {
        paymentEstimatorParamsObject = {
          pe_buy_lease: pricingDetails.finance_type,
          pe_credit_score: pricingDetails.selfReportedCreditScore,
          pe_apr_term: pricingDetails.months,
          pe_down_payment: pricingDetails.cashDown,
          pe_trade_in_value: pricingDetails.tradeIn,
          pe_annual_mileage: pricingDetails.miles,
          pe_owed_trade_in: pricingDetails.payOff
        }
      }
      return paymentEstimatorParamsObject;
    },
    'offerBlock': (dynamicOfferBlockParams) => {
      if (dynamicOfferBlockParams.title === "") {
        dynamicOfferBlockParams = {};
      } else if (dynamicOfferBlockParams.offerId === undefined) {
        dynamicOfferBlockParams.offerId = '';
        if (dynamicOfferBlockParams.category !== 'tfs') {
          dynamicOfferBlockParams.endDate = '';
        }
      }
      let offerBlockParams: any = {};
      if (dynamicOfferBlockParams !== undefined && dynamicOfferBlockParams !== null && Object.keys(dynamicOfferBlockParams).length > 0 && dynamicOfferBlockParams.title !== "") {
        offerBlockParams = {
          offer_id: (dynamicOfferBlockParams.offerId === undefined || dynamicOfferBlockParams.offerId === null || dynamicOfferBlockParams.offerId === '') ? '' : dynamicOfferBlockParams.offerId,
          offer_title: (dynamicOfferBlockParams.title === undefined || dynamicOfferBlockParams.title === null || dynamicOfferBlockParams.title === '') ? '' : dynamicOfferBlockParams.title,
          offer_type: (dynamicOfferBlockParams.type === undefined || dynamicOfferBlockParams.type === null || dynamicOfferBlockParams.type === '') ? 'Multiple_Vehicle' : dynamicOfferBlockParams.type,
          offer_category: (dynamicOfferBlockParams.category === undefined || dynamicOfferBlockParams.category === null || dynamicOfferBlockParams.category === '') ? '' : dynamicOfferBlockParams.category,
          offer_expired_date: (dynamicOfferBlockParams.endDate === undefined || dynamicOfferBlockParams.endDate === null || dynamicOfferBlockParams.endDate === '') ? '' : dynamicOfferBlockParams.endDate,
          offer_term: (dynamicOfferBlockParams.term === undefined || dynamicOfferBlockParams.term === null || dynamicOfferBlockParams.term === '') ? '' : dynamicOfferBlockParams.term,
          offer_label: '',
          offer_monthly: (dynamicOfferBlockParams.monthly !== undefined) ? dynamicOfferBlockParams.monthly : '',
          offer_rate: (dynamicOfferBlockParams.rate !== undefined) ? dynamicOfferBlockParams.rate : '',
          offer_amtdue: '',
          offer_cashback: ''
        }
      } else {
        offerBlockParams = {
          offer_id: '',
          offer_title: '',
          offer_type: '',
          offer_category: '',
          offer_expired_date: '',
          offer_term: '',
          offer_label: '',
          offer_monthly: '',
          offer_rate: '',
          offer_amtdue: '',
          offer_cashback: ''
        }
        for (const key in dynamicOfferBlockParams) {
          offerBlockParams[key] = dynamicOfferBlockParams[key];
        }
      }
      return offerBlockParams;
    },
    'offerVehicleBlock': (dynamicOfferVehicleBlockParams) => {
      let offerVehicleBlockParams: any = {};
      if (dynamicOfferVehicleBlockParams !== undefined && dynamicOfferVehicleBlockParams !== null && Object.keys(dynamicOfferVehicleBlockParams).length > 0) {
        offerVehicleBlockParams = {
          offer_series_accessories_name: '',//this.commonUtilities.constructAddedAccessoriesString(dynamicOfferVehicleBlockParams.addedAccessoriesArray),
          offer_series_brand: (dynamicOfferVehicleBlockParams.brand === undefined) ? '' : dynamicOfferVehicleBlockParams.brand,
          offer_series_code: (dynamicOfferVehicleBlockParams.series === undefined) ? '' : dynamicOfferVehicleBlockParams.series,
          offer_series_grade: (dynamicOfferVehicleBlockParams.trim === undefined) ? '' : dynamicOfferVehicleBlockParams.trim,
          offer_series_inventory_type: '',
          offer_series_vehicleid: '',
          offer_series_year: (dynamicOfferVehicleBlockParams.display_year === undefined) ? '' : dynamicOfferVehicleBlockParams.display_year,
          offer_series_body_style: (dynamicOfferVehicleBlockParams.bodyStyle === undefined) ? '' : dynamicOfferVehicleBlockParams.bodyStyle,
          // offer_series_category: (this.commonUtilities.getSelectedVehicleCategory() !== undefined && this.commonUtilities.getSelectedVehicleCategory() !== null) ? this.commonUtilities.getSelectedVehicleCategory() : '',
          offer_series_color_ext: (dynamicOfferVehicleBlockParams.exteriorColorDescription === undefined) ? '' : dynamicOfferVehicleBlockParams.exteriorColorDescription,
          offer_series_color_ext_code: (dynamicOfferVehicleBlockParams.exteriorColorCode === undefined) ? '' : dynamicOfferVehicleBlockParams.exteriorColorCode,
          offer_series_color_int: (dynamicOfferVehicleBlockParams.interiorColorDescription === undefined) ? '' : dynamicOfferVehicleBlockParams.interiorColorDescription,
          offer_series_color_int_code: (dynamicOfferVehicleBlockParams.interiorColorCode === undefined) ? '' : dynamicOfferVehicleBlockParams.interiorColorCode,
          offer_series_engine: (dynamicOfferVehicleBlockParams.transmission === undefined) ? '' : dynamicOfferVehicleBlockParams.transmission,
          offer_series_fuel_type: (dynamicOfferVehicleBlockParams.engine !== undefined && dynamicOfferVehicleBlockParams.engine.fuelType !== undefined) ? dynamicOfferVehicleBlockParams.engine.fuelType : '',
          offer_series_msrp: (dynamicOfferVehicleBlockParams.totalMsrp === undefined) ? '' : dynamicOfferVehicleBlockParams.totalMsrp,
          offer_series_number: (dynamicOfferVehicleBlockParams.model_code === undefined) ? '' : dynamicOfferVehicleBlockParams.model_code,
          // offer_series_packages: (dynamicOfferVehicleBlockParams.packagesAndOptions === undefined) ? '' : this.commonUtilities.constructPackagesAndOptionsString(dynamicOfferVehicleBlockParams.packagesAndOptions),
          offer_series_transmission: (dynamicOfferVehicleBlockParams.transmission === undefined) ? '' : dynamicOfferVehicleBlockParams.transmission,
          offer_series_used_inventory_cert_level:  (dynamicOfferVehicleBlockParams.transmission === undefined) ? '' : dynamicOfferVehicleBlockParams.vehicleDetailResponseObject.certificationType
        }
      } else {
        offerVehicleBlockParams = {
          offer_series_accessories_name: '',
          offer_series_brand: '',
          offer_series_code: '',
          offer_series_grade: '',
          offer_series_inventory_type: '',
          offer_series_vehicleid: '',
          offer_series_year: '',
          offer_series_body_style: '',
          offer_series_category: '',
          offer_series_color_ext: '',
          offer_series_color_ext_code: '',
          offer_series_color_int: '',
          offer_series_color_int_code: '',
          offer_series_engine: '',
          offer_series_fuel_type: '',
          offer_series_msrp: '',
          offer_series_number: '',
          offer_series_packages: '',
          offer_series_transmission: '',
          offer_series_used_inventory_cert_level:''
        }
      }
      for (const key in dynamicOfferVehicleBlockParams) {
        offerVehicleBlockParams[key] = dynamicOfferVehicleBlockParams[key];
      }
      return offerVehicleBlockParams;
    },
    'filterSeriesBlock': (dynamicFilterSeriesBlockParams) => {
      const filterSeriesBlockParams = {
        filter_series_code: '',
        filter_series_year: '',
        filter_series_inventory_type:'',
        filter_series_certification_level:''
      }
      for (const key in dynamicFilterSeriesBlockParams) {
        filterSeriesBlockParams[key] = dynamicFilterSeriesBlockParams[key];
      }
      return filterSeriesBlockParams;
    },
    'listBlock': (dynamicListBlockParams) => {
      const listBlockParams = {
        list_result_count: '',
        list_layout: '',
        list_item_index: ''
      }
      for (const key in dynamicListBlockParams) {
        listBlockParams[key] = dynamicListBlockParams[key];
      }
      return listBlockParams;
    },
    'listItemBlock': (dynamicListItemBlockParams) => {
      const listItemBlockParams = {
        list_item_index: ''
      }
      for (const key in dynamicListItemBlockParams) {
        listItemBlockParams[key] = dynamicListItemBlockParams[key];
      }
      return listItemBlockParams;
    },
    'partBlock': (dynamicPartBlockParams) => {
      if (dynamicPartBlockParams instanceof Array) {
        const partBlockParams = {
          'parts_id': '',
          'parts_name': '',
          'parts_category': '',
          'parts_msrp': 0,
          'content_section': '',
        }
        let parts_msrp = 0;
        const parts_id: any[] = [];
        const parts_name: any[] = [];
        const parts_category: any[] = [];
          dynamicPartBlockParams.forEach(element => {
          parts_id.push(element?.partNbr);
          parts_name.push(element?.marketingName);
          parts_category.push(element?.type);
          parts_msrp = parts_msrp + + Number(element?.price);
        });
        partBlockParams.parts_id = parts_id.toString();
        partBlockParams.parts_name = parts_name.toString();
        partBlockParams.parts_category = parts_category.toString();
        partBlockParams.parts_msrp = parts_msrp;
        return partBlockParams;
      } else if (dynamicPartBlockParams instanceof Object) {
        const partBlockParams = {
          'parts_id': '',
          'parts_name': '',
          'parts_category': '',
          'content_section': '',
        }
        partBlockParams.parts_id = dynamicPartBlockParams?.parts_id || '';
        partBlockParams.parts_name = dynamicPartBlockParams?.parts_name || '';
        partBlockParams.parts_category = dynamicPartBlockParams?.parts_category || '';
        partBlockParams.content_section = dynamicPartBlockParams?.content_section || '';
        return partBlockParams;       
      }
     
    },
    'insuranceProductBlock': (dynamicInsuranceProductBlockParams)  => {
      const data = {
        mst_insurance_prod_id : '',
        mst_insurance_prod_title : '',
        mst_insurance_prod_msrp : 0
      }
      let prod_msrp = 0;
        if (dynamicInsuranceProductBlockParams instanceof Array) {         
        const mst_insurance_prod_id: any[] = [];
        const mst_insurance_prod_title: any[] = [];        
        dynamicInsuranceProductBlockParams.forEach(element => {
            mst_insurance_prod_id.push(element?.productCode);
            mst_insurance_prod_title.push(element?.productName);
            prod_msrp = prod_msrp + Number(element?.dealerSellingPrice);
        });
        data.mst_insurance_prod_id = mst_insurance_prod_id.toString();
        data.mst_insurance_prod_title = mst_insurance_prod_title.toString();
        data.mst_insurance_prod_msrp = prod_msrp;
        return data;
    } else if (dynamicInsuranceProductBlockParams instanceof Object) {
        data.mst_insurance_prod_id = dynamicInsuranceProductBlockParams?.mst_insurance_Prod_id || '';
        data.mst_insurance_prod_title = dynamicInsuranceProductBlockParams?.mst_insurance_Prod_title || '';
        dynamicInsuranceProductBlockParams?.mst_insurance_prod_msrp ?  data.mst_insurance_prod_msrp = Number(dynamicInsuranceProductBlockParams?.mst_insurance_prod_msrp) : delete data.mst_insurance_prod_msrp;
        return data;
      }
   
    },
    'videoEventBlock': (dynamicVideoEventBlockParams) => {
      const videoEventBlockParams = {
        video_event_title: '',
        video_event_duration: '',
        video_event_playhead: '',
        video_event_last_action: '',
        video_link: ''
      }
      for (const key in dynamicVideoEventBlockParams) {
        videoEventBlockParams[key] = dynamicVideoEventBlockParams[key];
      }
      return videoEventBlockParams;
    },
    'multiVehicleBlock': (dynamicMultiVehicleBlockParams) => {
      const multiVehicleBlockParams = {
        multi_series_code_year: ''
      }
      for (const key in dynamicMultiVehicleBlockParams) {
        multiVehicleBlockParams[key] = dynamicMultiVehicleBlockParams[key];
      }
      return multiVehicleBlockParams;
    },
    'offerListBlock': (dynamicOfferListBlockParams) => {
      const offerListBlockParams = {
        offer_list_filter: '',
        offer_list_selector: ''
      }
      for (const key in dynamicOfferListBlockParams) {
        offerListBlockParams[key] = dynamicOfferListBlockParams[key];
      }
      return offerListBlockParams;
    },
    'userInputErrorBlock': (dynamicUserInputErrorBlockParams) => {
      const userInputErrorBlockParams = {
        displayed_error_message: ''
      }
      for (const key in dynamicUserInputErrorBlockParams) {
        userInputErrorBlockParams[key] = dynamicUserInputErrorBlockParams[key];
      }
      return userInputErrorBlockParams;
    },
    'contentSearchBlock': (dynamicContentSearchBlockParams) => {
      const contentSearchBlockParams = {
        search_term: '',
        search_type: ''
      }
      for (const key in dynamicContentSearchBlockParams) {
        contentSearchBlockParams[key] = dynamicContentSearchBlockParams[key];
      }
      return contentSearchBlockParams;
    },
    'userBlock': (dynamicUserBlock) => {
      const userBlockParams = {
        user_role: ''
      }
      for (const key in dynamicUserBlock) {
        userBlockParams[key] = dynamicUserBlock[key];
      }
      return userBlockParams;
    },
    'dealerBlock': (dealerBlockParamsObject) => {
      const dealerParamsObject: any = {
        dealer_value: '',
      }
      for (const key in dealerBlockParamsObject) {
        dealerParamsObject[key] = dealerBlockParamsObject[key];
      }
      return dealerParamsObject;
    },
    'signalBlock':(dealerBlockParamsObject) => {
      const dealerParamsObject: any = {
        signal_flags: '',
      }
      for (const key in dealerBlockParamsObject) {
        dealerParamsObject[key] = dealerBlockParamsObject[key];
      }
      return dealerParamsObject;
    },
    'customerBlock': (dynamicCustomerBlockParams) => {
      const customerBlockParams: any = {
        customer_id: '',
        customer_type: '',
        customer_status: ''
      };

      for (const key in dynamicCustomerBlockParams) {
        customerBlockParams[key] = dynamicCustomerBlockParams[key];
      }
      return customerBlockParams;
    },
  }
  getDeviceInfo() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    if (isMobile) {
      this.deviceType = 'mobile';
    } else if (isTablet) {
      this.deviceType = 'tablet';
    } else {
      this.deviceType = 'desktop';
    }
  }
  private concatenateBlocks(globalParams, blockParams): any {
    if (blockParams !== undefined && blockParams !== null) {
      for (const element in blockParams) {
        globalParams[element] = blockParams[element];
      };
    }
    return globalParams;
  }

  public captureAnalytics(eventType, _pageIdentifier, blockParamsDictionary) {
    try {
      let fireEvent = '';
      const fireEventParams: any = {};
      if (eventType === ViewConstants.EVENT_PAGE_LOAD) {
        fireEvent = 'cs-pageload';
      } else if (eventType === ViewConstants.AA_EVENT_PAGE_LOAD) {
        fireEvent = 'aa-pageload';
      }
      else if (eventType === ViewConstants.EVENT_LINK) {
        fireEvent = 'aa-link';
      }
      else {
        fireEvent = eventType;
      }
      for (const element in blockParamsDictionary) {
        this.concatenateBlocks(fireEventParams, this.paramsDictionary[element](blockParamsDictionary[element]));
      }
      // Avoid runtime crashes in environments where the analytics tag library is not loaded.
      if (typeof CONfireTag === 'function') {
        CONfireTag(fireEvent, fireEventParams);
      }
    } catch (error) {
      console.error(error)
    }
  }
  private setCustomerValues(value){
    if(value && globalThis.location.href.includes('writeup-detail')){
      return value;
    }else{
      return '';
    }
  }
}